import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

export const ArrowUp:React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M15 13.4155L10 8.4155L5 13.4155" stroke="currentColor" fill="transparent" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>
)
